import { GetStaticProps } from 'next';
import { GetStaticPropsContext } from 'next/types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import InformationSection from '@features/showroom/sections/Information/InformationSection';
import MapSection from '@features/showroom/sections/Map/MapSection';
import { getShowroomData } from '@features/showroom/api';
import { IInformationItems, ILocationItems } from '@features/showroom/typescript';
import { getLayoutData } from '@features/layout/api';
import { ISeo, TLocale } from '@typescript/index';
import MainSeo from '@components/MainSeo/MainSeo';
import { REVALIDATION_TIME } from '@config/index';
import { getDevProps } from '@components/DevToolbar/helpers/getDevProps';
type PropsType = {
  informations: Array<IInformationItems>;
  locations: Array<ILocationItems>;
  seo: ISeo;
  isBuildTime?: boolean;
};
const Showroom = ({
  seo,
  informations,
  locations,
  isBuildTime
}: PropsType) => {
  if (isBuildTime) {
    return <div>Build time</div>;
  }
  return <main id="main-content">
      {seo && <MainSeo seo={seo} />}
      <MapSection locations={locations} />
      <InformationSection informations={informations} />
    </main>;
};
export const getStaticProps: GetStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  if (process.env.IS_BUILD) {
    return {
      props: {
        isBuildTime: true
      },
      revalidate: 1
    };
  }
  return {
    props: {
      ...getDevProps('static', REVALIDATION_TIME),
      ...(await getShowroomData(locale)),
      isBuildTime: false,
      ...(await getLayoutData(locale as TLocale)),
      ...(await serverSideTranslations(locale as string))
    },
    revalidate: REVALIDATION_TIME
  };
};
export default Showroom;